import { Controller } from "@hotwired/stimulus"

// The onboarding "What best describes your role?" multi-select. Each toggle
// POSTs the FULL current selection — the loading screen underneath advances on
// its own (Turbo refresh / poll), so there is no submit moment and a partial
// answer must already be persisted. Fire-and-forget: a failed save never
// interrupts onboarding.
export default class extends Controller {
  static targets = ["chip"]
  static values = { url: String }

  toggle(event) {
    const chip = event.currentTarget
    const on = chip.getAttribute("aria-pressed") === "true"
    chip.setAttribute("aria-pressed", on ? "false" : "true")
    this.save()
  }

  save() {
    const roles = this.chipTargets
      .filter((c) => c.getAttribute("aria-pressed") === "true")
      .map((c) => c.dataset.role)
    const body = new FormData()
    roles.forEach((r) => body.append("roles[]", r))
    fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content },
      body
    }).catch(() => {})
  }
}
